import type { Theme } from '@mui/material/styles';

/** Colour of an online share: success from 90%, warning from 70%, error below that, and muted without meters. */
export const onlineStatusColor = (
  theme: Theme,
  online: number,
  total: number
): string => {
  if (total === 0) return theme.tokens.colors.mutedForeground;
  const percentage = (online / total) * 100;
  if (percentage >= 90) return theme.palette.success.main;
  if (percentage >= 70) return theme.palette.warning.main;
  return theme.palette.error.main;
};
